export default {
  emojisData: [],
};
